import { FileClient } from "../RestClient";
import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B060010FindRequest = Partial<{
  hakkoKbn: string;
  shohinshubetsuKbn: string;
  shainCd: string;
  juchuYmdFrom: string;
  juchuYmdTo: string;
  seisakuYmdFrom: string;
  seisakuYmdTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  kanryoKbn: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B060010FindResponse = {
  eigyoCd: string;
  eigyoNmr: string;
  juchudenpyoNo: string;
  juchuYmd: string;
  tokuiCd: string;
  tokuishitenCd: string;
  tokuiNm: string;
  nonyuCd: string;
  nonyushitenCd: string;
  nonyuNm: string;
  shainCd: string;
  shainNm: string;
  biko: string;
  shohinshubetsuKbn: string;
  juchugyoNo: string;
  seizoNo: string;
  meisaiShohinCd: string;
  meisaiShohinNm: string;
  meisaiVol: string;
  meisaibiko: string;
  kakoshubetsuCd: string;
  meishoNm1: string;
  meisaiWhsoto: string;
  meisaiWhuchi: string;
  seisakuYmd: string;
  juchusu: string;
  shireYmd: string;
  shiresu: string;
  meisaiJodaitanka: string;
  seizozansu: string;
  kanryoKbn: string;
  juchukoseigyoNo: string;
  koseiShohinCd: string;
  koseiShohinNm: string;
  koseiVol: string;
  meisaikoseiBiko: string;
  koseiWhsoto: string;
  koseiWhuchi: string;
  koseisu: string;
  koseiJodaitanka: string;
};

export const B060010Find = (props: B060010FindRequest) => {
  return RestClient.get<PageableResponse<B060010FindResponse>>("b060010/find", {
    params: props,
  });
};

export type B060010ExcelRequest = Partial<{
  hakkoKbn: string;
  shohinshubetsuKbn: string;
  shainCd: string;
  juchuYmdFrom: string;
  juchuYmdTo: string;
  seisakuYmdFrom: string;
  seisakuYmdTo: string;
  juchudenpyoNoFrom: string;
  juchudenpyoNoTo: string;
  kanryoKbn: string;
  sort: string[];
}>;

// Excel出力処理
export const B060010GetExcel = (props: B060010ExcelRequest) => {
  return FileClient.get("b060010/get/excel", {
    params: props,
  });
};
